module.exports = __webpack_public_path__ + "img/pickup-agent-hub.acc0159a.svg";